const primary = {
  50: "#c7fff6",
  100: "#90ffee",
  200: "#51f7e4",
  300: "#1de4d4",
  400: "#04c8bb",
  500: "#00b4ac",
  600: "#05807b",
  700: "#0a6563",
  800: "#0d5452",
  900: "#003233",
  950: "#001d1d",
};

module.exports = {
  primary,
};
